<template>
  <div class="frisbuy-sr-block">
    <FrisbuySrInstagram
      v-if="!settings.censorship.hide_ig && !isInline && false"
      :isHide="canStoriesNavigatePrev"
      :hideDirection="settings.widget.rightSide == 1 ? 'right' : 'none'"
    />
    <FrisbuySrNavigationButton
      v-if="!isInline"
      @click="() => scrollFixedStories(-2)"
      :isHidden="!canStoriesNavigatePrev"
      direction="top"
    />
    <FrisbuySrStories
      @selectStory="selectStory"
      @canNavigatePrev="(val) => (canStoriesNavigatePrev = val)"
      @canNavigateNext="(val) => (canStoriesNavigateNext = val)"
      :stories="stories"
      :selectedStory="selectedStory"
      :visited="visited"
      ref="FrisbuySrStories"
    />
    <FrisbuySrNavigationButton
      v-if="!isInline"
      @click="() => scrollFixedStories(2)"
      direction="bottom"
      :isDisabled="canStoriesNavigateNext"
    />
    <FrisbuySrBranding
      v-if="isSeenBrandLogo"
      :utmCampaing="settings.customerCode"
    />
  </div>
</template>

<style scoped lang="scss">
.frisbuy-sr-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  height: 100%;
  position: relative;
  background: #fff;
  border-radius: 0 16px 16px 0;
  z-index: 2;
  padding: 8px 0;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.24), 0px 4px 16px rgba(0, 0, 0, 0.08);
  transition: box-shadow 2s 0s;
}

@media (max-height: 700px) and (min-width: 768px) {
  .frisbuy-sr-block {
    padding: 7px 0;
  }
}
</style>

<script>
import FrisbuySrBranding from "./FrisbuySrBranding.vue";
import FrisbuySrInstagram from "./FrisbuySrInstagram.vue";
import FrisbuySrNavigationButton from "./FrisbuySrNavigationButton.vue";
import FrisbuySrStories from "./FrisbuySrStories.vue";

export default {
  inject: ["settings"],

  components: {
    FrisbuySrInstagram,
    FrisbuySrNavigationButton,
    FrisbuySrBranding,
    FrisbuySrStories,
  },

  data() {
    return {
      canStoriesNavigatePrev: false,
      canStoriesNavigateNext: false,
    };
  },

  props: {
    stories: {
      type: Array,
      require: false,
      default: () => [],
    },

    selectedStory: {
      require: false,
      default: null,
    },

    visited: {
      type: Array,
      require: false,
      default: () => [],
    },

    isInline: {
      type: Boolean,
      require: false,
      default: false,
    },

    isSeenBrandLogo: {
      type: Boolean,
      require: false,
      default: true,
    },
  },

  emits: ["selectStory"],

  methods: {
    selectStory(story, event) {
      const storyIndex = this.stories.indexOf(story);
      const itemToScroll =
        this.$refs.FrisbuySrStories.$refs.FrisbuySrStory[storyIndex].$el;

      if (
        this.selectedStory &&
        !this.isTablet &&
        !this.settings.widget.mobileFixed
      ) {
        itemToScroll.scrollIntoView({
          block: "center",
          behavior: "smooth",
          inline: "center",
        });
      }

      this.$emit("selectStory", story, event);
    },

    scrollFixedStories(step) {
      this.$refs.FrisbuySrStories.storiesScrolling(step);
    },
  },

  computed: {
    isTablet: {
      cache: false,
      get() {
        return (
          Math.min(window.innerWidth, screen.width) < 568 ||
          Math.min(window.innerHeight, screen.height) < 426
        );
      },
    },
  },
};
</script>
